import moment from 'moment'
import {
  getDateToSubmit,
  getDateWeek,
  getDateMonth,
  getDateYear,
} from 'shared/utils/dateFormatting'

export const getRangeDateFromType = (type) => {
  switch (type) {
    case 'week': {
      return {
        fromDate: getDateToSubmit(getDateWeek().startOf('day')),
        toDate: getDateToSubmit(moment().startOf('day')),
      }
    }
    case 'month': {
      return {
        fromDate: getDateToSubmit(getDateMonth().startOf('day')),
        toDate: getDateToSubmit(moment().startOf('day')),
      }
    }
    case 'year': {
      return {
        fromDate: getDateToSubmit(getDateYear().startOf('day')),
        toDate: getDateToSubmit(moment().startOf('day')),
      }
    }
    default:
      return null
  }
}
